export default "__VITE_ASSET__MnE5_8$m__"